var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSolidGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_2733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 17.0802 17.0794 22 11 22C4.91975 22 0 17.0794 0 11C0 4.91975 4.92059 0 11 0C17.0802 0 22 4.92059 22 11Z",
    fill: "#4CB944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4768 9.16722C15.8125 8.83169 15.8125 8.28753 15.4768 7.95184C15.1413 7.61631 14.5971 7.61631 14.2614 7.95184L9.10384 13.1096L6.96698 10.9727C6.63145 10.6371 6.0873 10.6371 5.75177 10.9727C5.41608 11.3083 5.41608 11.8524 5.75177 12.188L8.49623 14.9326C8.83192 15.2681 9.37592 15.2681 9.71161 14.9326L15.4768 9.16722Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_2733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolidGreen);
export default __webpack_public_path__ + "static/media/CheckSolidGreen.bf0fce58d78d806fbfe2c60112327fcb.svg";
export { ForwardRef as ReactComponent };